var $bae512bb9143bcfd$exports = {};
$bae512bb9143bcfd$exports = {
    "valid": `Gyldig`
};


export {$bae512bb9143bcfd$exports as default};
//# sourceMappingURL=da-DK.mjs.map
